import React from "react";

// No tooltips added due to style positioning bug from fullscreening the modal
export const Removal790AColumns = ({ linkageDeletionId, removeRow }) => [
  {
    Header: "Legal Business Name",
    id: "legalName",
    fixedWidth: 200,
    accessor: (data) => data.legalName,
    Cell: ({ value, row: { index }, column: { id } }) => {
      const tooltipId = `${id}_${index}`;
      return (
        <span data-tip data-for={tooltipId}>
          {value || "--"}
        </span>
      );
    },
  },
  {
    Header: "FEIN",
    id: "agricFeinId",
    fixedWidth: 120,
    accessor: (data) => data.agricFeinId,
    Cell: ({ value, row: { index }, column: { id } }) => {
      const tooltipId = `${id}_${index}`;
      return (
        <span data-tip data-for={tooltipId}>
          {value || "--"}
        </span>
      );
    },
  },
  {
    Header: "State",
    id: "employment_state_id",
    fixedWidth: 150,
    accessor: (data) => data.employment_state_id,
    Cell: ({ value, row: { index }, column: { id } }) => {
      const tooltipId = `${id}_${index}`;
      return (
        <span data-tip data-for={tooltipId}>
          {value || "--"}
        </span>
      );
    },
  },
  {
    Header: "County",
    id: "employment_county_id",
    fixedWidth: 150,
    accessor: (data) => data.employment_county_id?.label,
    Cell: ({ value, row: { index }, column: { id } }) => {
      const tooltipId = `${id}_${index}`;
      return (
        <span data-tip data-for={tooltipId}>
          {value || "--"}
        </span>
      );
    },
  },
  {
    Header: "Crop and Agricultural Activity",
    id: "crop_ids",
    accessor: (data) => data.crop_ids,
    Cell: ({ value, row: { index }, column: { id } }) => {
      const tooltipId = `${id}_${index}`;
      return (
        <span data-tip data-for={tooltipId}>
          {value?.map((item, i) => {
            const commaSeparator = `${i ? ", " : ""}`;

            if (item === linkageDeletionId && !removeRow) {
              return (
                <>
                  {commaSeparator}
                  <strong
                    style={{
                      color: "red",
                      textDecoration: "line-through",
                    }}
                  >
                    <em>{item}</em>
                  </strong>
                </>
              );
            } else {
              return `${commaSeparator} ${item}`;
            }
          })}
        </span>
      );
    },
  },
  {
    Header: "Additional Information",
    id: "additional_info",
    // fixedWidth: 150,
    accessor: (data) => data.additional_info,
    Cell: ({ value, row: { index }, column: { id } }) => {
      const tooltipId = `${id}_${index}`;
      return (
        <span data-tip data-for={tooltipId}>
          {value || "--"}
        </span>
      );
    },
  },
  {
    Header: "Additional Activity",
    id: "additionalActivity",
    accessor: (data) => data.additionalActivity,
    minWidth: 400,
    Cell: ({ value, row: { index }, column: { id } }) => {
      const tooltipId = `${id}_${index}`;
      return (
        <span data-tip data-for={tooltipId}>
          {value || "--"}
        </span>
      );
    },
  },
];
